import {
  HandlersActionCatalogResponse,
  useDeleteApiActionsByActionNameMutation,
  useGetApiActionsQuery,
  usePatchApiActionsByActionNameMutation,
  usePostApiActionsMutation,
} from '../../../../app/athenaApiGen';
import AdminCatalogPanel from '../AdminCatalogPanel';

const AdminActionsPanel = () => (
  <AdminCatalogPanel<HandlersActionCatalogResponse>
    tableName="Action"
    apiPath="/api/actions"
    pkAccessor="actionName"
    useList={() => useGetApiActionsQuery({ includeArchived: true })}
    useCreate={usePostApiActionsMutation}
    useUpdate={usePatchApiActionsByActionNameMutation}
    useDelete={useDeleteApiActionsByActionNameMutation}
    buildCreateArg={(v) => ({ handlersCreateActionRequest: v })}
    buildUpdateArg={(row, v) => ({
      actionName: row.actionName as string,
      handlersUpdateActionRequest: v,
    })}
    buildDeleteArg={(row) => ({ actionName: row.actionName as string })}
    fields={[
      {
        name: 'actionName',
        label: 'Action Name',
        type: 'text',
        required: true,
        immutableOnEdit: true,
        helperText: 'String identifier; cannot be renamed after creation.',
      },
      { name: 'description', label: 'Description', type: 'textarea' },
      { name: 'actionType', label: 'Action Type', type: 'text' },
      { name: 'actionScope', label: 'Action Scope', type: 'text' },
      { name: 'archived', label: 'Archived', type: 'boolean' },
    ]}
    fkConflictMessage="This action is referenced by one or more roles. Remove the role-action assignments before deleting."
  />
);

export default AdminActionsPanel;
